export default __webpack_public_path__ + "static/1361-657497e53c43f7b8dcc51fd165ed71dd.gif";